<template>
    <form>
        <div class="row q-col-gutter-md">
            <div class="col col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <q-select
                    v-model="TradeObj.pair_id"
                    :label="$t('trades.table_titles.exchange')"
                    emit-value
                    map-options
                    option-value="id"
                    option-label="symbol"
                    :options="pairs"
                    :loading="loading"
                    :error="TradeObj.errors.has('pair_id')"
                    :error-message="TradeObj.errors.get('pair_id')"
                    :rules="[ val => val && val > 0 || $t('trades.table_titles.exchange') + ' is required!']"
                    color="input-color"
                >
                    <template v-slot:selected-item="scope">
                        <div v-if="Object(scope.opt) === scope.opt && 'exchange' in scope.opt">
                            {{ scope.opt.exchange.name }} - <span class="text-caption text-grey">({{
                                scope.opt.symbol
                            }})</span></div>
                    </template>
                    <template v-slot:option="scope">
                        <q-item
                            v-bind="scope.itemProps"
                            v-on="scope.itemEvents"
                            style="border-bottom:1px solid #999"
                        >
                            <q-item-section>
                                <q-item-label lines="1">
                                    <span class="text-weight-medium text-uppercase">{{ scope.opt.exchange.name }}</span>
                                    <span> - </span>
                                    <span class="text-bold text-caption text-grey">({{ scope.opt.symbol }})</span>
                                </q-item-label>
                            </q-item-section>
                        </q-item>
                    </template>
                </q-select>
            </div> <!-- EXCHANGE -->
            <div class="col col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <q-select
                    v-model="TradeObj.role"
                    :label="$t('trades.table_titles.role')"
                    :options="roles"
                    :error="TradeObj.errors.has('role')"
                    :error-message="TradeObj.errors.get('role')"
                    color="input-color"
                />
            </div> <!-- ROLE -->
            <div class="col col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <q-select
                    v-model="TradeObj.side"
                    :label="$t('trades.table_titles.side')"
                    :options="sides"
                    :error="TradeObj.errors.has('side')"
                    :error-message="TradeObj.errors.get('side')"
                    color="input-color"
                />
            </div> <!-- SIDE -->
            <div class="col col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <q-input
                    v-model="TradeObj.amount"
                    :label="$t('trades.table_titles.amount')"
                    :error="TradeObj.errors.has('amount')"
                    :error-message="TradeObj.errors.get('amount')"
                    input-class="text-center"
                    color="input-color"
                    type="number"
                >
                    <template v-slot:append>
                        <q-icon name="fa fa-coins"/>
                    </template>
                </q-input>
            </div> <!-- AMOUNT -->
            <div class="col col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <q-input
                    v-model="TradeObj.price"
                    :label="$t('trades.table_titles.price')"
                    :error="TradeObj.errors.has('price')"
                    :error-message="TradeObj.errors.get('price')"
                    input-class="text-center"
                    color="input-color"
                    type="number"
                >
                    <template v-slot:append>
                        <q-icon name="fa fa-dollar-sign"/>
                    </template>
                </q-input>
            </div> <!-- PRICE -->
            <div class="col col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <q-input
                    v-model="TradeObj.fee"
                    :label="$t('trades.table_titles.fee')"
                    :error="TradeObj.errors.has('fee')"
                    :error-message="TradeObj.errors.get('fee')"
                    input-class="text-center"
                    color="input-color"
                    type="number"
                />
            </div> <!-- FEE -->
            <div class="col col-xs-12 col-sm-6 col-md-3 col-lg-3">
                <q-select
                    v-model="TradeObj.status"
                    :label="$t('trades.table_titles.status')"
                    :options="statuses"
                    :error="TradeObj.errors.has('status')"
                    :error-message="TradeObj.errors.get('status')"
                    color="input-color"
                />
            </div> <!-- SIDE -->
        </div>
    </form>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
    name: 'Form',
    model: {
        prop: 'TradeObj',
        event: 'change'
    },
    props: {
        TradeObj: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters(['pairs']),
    },
    data() {
        return {
            loading: false,
            roles: ['MAKER', 'TAKER'],
            sides: ['SELL', 'BUY'],
            statuses: ['NEW', 'CANCELED', 'REPLACED', 'REJECTED', 'TRADED', 'EXPIRED'],
        }
    },
    methods: {
        ...mapActions(['set_pairs']),
    },
    created() {
        if (!this.pairs.length) {
            this.loading = true
            this.set_pairs().then(() => {
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    },
    components: {},
}
</script>

<style scoped>

</style>
